/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * What the date under the status badge refers to.
 */
export enum SurveySeasonSurveyReviewStatusDateKind {
    UPLOADED = 'uploaded',
    VENDOR_PUBLISHES = 'vendorPublishes',
}
